import { defineComponent as _defineComponent } from 'vue'
import { ActiveComponent } from "@/views/settings.vue";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'active-icon-watermark.component',
  props: {
    activeComponent: null
  },
  setup(__props: any) {

const props = __props as {
  activeComponent: ActiveComponent;
}



const isHeartBeating = ref(false);

// Watch for activeComponent changes
watch(
  () => props.activeComponent,
  () => {
    isHeartBeating.value = true;
    setTimeout(() => {
      isHeartBeating.value = false;
    }, 500);
  }
);

return { __sfc: true,props, isHeartBeating }
}

})